import Link from 'next/link';

import { useAuth } from '@/api';
import { useGetOrders } from '@/api/forex/orders/useGetOrders';
import { useGetCustomerId } from '@/api/forex/user-info/useGetCustomerId';
import routes from '@/routes/routes.json';
import { formatToTime } from '@/utils';
import { toTitleCase } from '@/utils/functions/orderSchemeStatus';

import {
  formatDate,
  formatTransactionType,
  fxOrderStatusColor,
} from '../../utils';

export const ForexPastTransactions = () => {
  const { userDetails } = useAuth();
  const { fxCustomerId: forexCustomerId } = useGetCustomerId({
    customerId: userDetails?.id || '',
  });
  const { ordersData, isLoading } = useGetOrders({
    customerId: forexCustomerId || '',
    pageNumber: 0,
    pageSize: 15,
  });

  return (
    <div className="loanDetails__card loanCard">
      <div className="loanCard__title-withChips">
        <p className="loanCard__title with-desc text--bold text--black">
          Past Transactions
        </p>
        {ordersData.length !== 0 && (
          <Link
            href={routes.forexOrders}
            id="DG_buy-gold-past-transactions"
            // href={`${routes.accountSettings}?tab="myOrder-tab"&my-order-tab="eSwarnaDigitalGold-tab"`}
            className="text--darkBlue text--bold moreLink"
          >
            View All
          </Link>
        )}
      </div>
      <div className="pastTransactions">
        {ordersData.length !== 0 &&
          !isLoading &&
          ordersData.slice(0, 5).map((data, index) => {
            const isCurrencyRequest = data.category === 'lead';
            return (
              <Link
                href={
                  isCurrencyRequest
                    ? `forex/v1/orders?orderId=${data.orderId}&category=${data.category}`
                    : `/forex/v1/orders?orderId=${data.refId}`
                }
                className="item"
                key={index}
              >
                <div className="right">
                  <div className="item__row">
                    <p className="text--semi text--black title">
                      {' '}
                      {data.category === 'lead'
                        ? formatTransactionType('CURRENCY_REQUEST')
                        : formatTransactionType(data.transactionType)}
                    </p>
                    {/* TODO :  Removed single transaction item redirection arrow icon */}
                    <span className="circleArrow-icon"></span>
                  </div>
                  <div className="item__row">
                    <p className="text--regular text--black nature">
                      Order ID: {data.orderId}
                    </p>
                    <p className="text--bold text--black price text-right">
                      ₹
                      {data.payments[0]?.amountPayable.toLocaleString('en-IN', {
                        maximumFractionDigits: 2,
                      })}
                    </p>
                  </div>
                  <div className="item__row">
                    <p
                      className={`${fxOrderStatusColor(
                        data.transactionStatus
                      )} text--regular status-size`}
                    >
                      {toTitleCase(
                        (data.transactionStatus === 'PAID' &&
                          (data.transactionType === 'SELL' ||
                            data.transactionType === 'CARD_UNLOAD')) ||
                          data.category === 'lead'
                          ? 'Placed'
                          : data.transactionStatus
                      )}
                    </p>
                    <p className="text--regular text--black date">
                      {formatDate(data.createdAt)}
                      <span className="pipe">|</span>{' '}
                      {formatToTime(data.createdAt)}
                      {/* {formatOrderTimestamp(
                        data.payments[0].paymentCreatedAt
                      )} */}
                      {/* {formatDate(data.payments[0].paymentCreatedAt)} */}
                    </p>
                  </div>
                </div>
              </Link>
            );
          })}
        {ordersData.length === 0 && !isLoading && (
          <p className="no-results-found-text">No Past Transactions Found</p>
        )}
        {isLoading && <p className="no-results-found-text">Loading...</p>}
      </div>
    </div>
  );
};
